import { _ as __rest } from '../tslib.es6-c563c1dd.js';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import { Backdrop } from '@mui/material';
import { Loading } from './Loading.js';

const PREFIX = 'FullScreenBackdrop';
const classes = {
    backdrop: `${PREFIX}-backdrop`,
};
const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
    [`&.${classes.backdrop}`]: {
        zIndex: theme.zIndex.drawer + 1,
        color: theme.palette.primary.main,
    },
}));
const FullScreenBackdrop = (_a) => {
    var { open, message } = _a, rest = __rest(_a, ["open", "message"]);
    return (jsx(StyledBackdrop, Object.assign({ className: classes.backdrop, open: open }, rest, { children: jsx(Loading, { message: message }) })));
};

export { FullScreenBackdrop };
